// @ts-nocheck
import { Link } from "react-router-dom";
import {
  BookPlus,
  BookOpen,
  BookCheck,
  ScrollText,
  Users,
  BarChart3,
  ArrowRight,
} from "lucide-react";
import { cn } from "@libraryadmin/lib/utils";

const actions = [
  {
    label: "Add New Book",
    description: "Add books to catalog",
    icon: BookPlus,
    href: "/vault-library-admin/book-entry",
    variant: "primary",
  },
  {
    label: "Issue Book",
    description: "Issue to members",
    icon: BookOpen,
    href: "/vault-library-admin/book-issue",
    variant: "secondary",
  },
  {
    label: "Receive Book",
    description: "Process returns",
    icon: BookCheck,
    href: "/vault-library-admin/book-receive",
    variant: "accent",
  },
  {
    label: "Manuscripts",
    description: "Jain sacred texts",
    icon: ScrollText,
    href: "/vault-library-admin/manuscripts",
    variant: "info",
  },
  {
    label: "Members",
    description: "Manage members",
    icon: Users,
    href: "/vault-library-admin/members",
    variant: "success",
  },
  {
    label: "Reports",
    description: "View analytics",
    icon: BarChart3,
    href: "/vault-library-admin/reports",
    variant: "warning",
  },
];

const variantStyles = {
  primary:
    "bg-primary/5 hover:bg-primary/10 border-primary/10 hover:border-primary/20 text-primary",
  secondary:
    "bg-secondary/5 hover:bg-secondary/10 border-secondary/10 hover:border-secondary/20 text-secondary",
  accent:
    "bg-accent/5 hover:bg-accent/10 border-accent/10 hover:border-accent/20 text-accent",
  info: "bg-info/5 hover:bg-info/10 border-info/10 hover:border-info/20 text-info",
  success:
    "bg-success/5 hover:bg-success/10 border-success/10 hover:border-success/20 text-success",
  warning:
    "bg-warning/5 hover:bg-warning/10 border-warning/10 hover:border-warning/20 text-warning",
};

export function QuickActions() {
  return (
    <div
      className="card-elevated animate-fade-in"
      style={{ animationDelay: "0.2s" }}
    >
      <div className="mb-5 flex items-center justify-between">
        <div>
          <h3 className="text-lg font-semibold text-foreground">
            Quick Actions
          </h3>
          <p className="text-sm text-muted-foreground">Common library tasks</p>
        </div>
      </div>
      <div className="grid grid-cols-2 gap-3 md:grid-cols-3">
        {actions.map((action, index) => (
          <Link
            key={action.href}
            to={action.href}
            className={cn(
              "animate-fade-in group flex flex-col rounded-xl border p-4 opacity-0 transition-all duration-300 hover:shadow-md",
              variantStyles[action.variant as keyof typeof variantStyles]
            )}
            style={{
              animationDelay: `${(index + 2) * 0.05}s`,
              animationFillMode: "forwards",
            }}
          >
            <div className="mb-2 flex items-center justify-between">
              <action.icon className="h-5 w-5" />
              <ArrowRight className="h-4 w-4 -translate-x-2 opacity-0 transition-all duration-300 group-hover:translate-x-0 group-hover:opacity-100" />
            </div>
            <span className="text-sm font-semibold text-foreground">
              {action.label}
            </span>
            <span className="mt-0.5 text-xs text-muted-foreground">
              {action.description}
            </span>
          </Link>
        ))}
      </div>
    </div>
  );
}
